<template>
  <div>
    <div :id="Id" class="sidebar" :class="{sidebar_open: value}">
      <slot v-if="value"></slot>
    </div>
  </div>
</template>
<script>
import('./style.css');

export default {
  name: 'Sidebar',
  props: {
    Id: {
      type: String,
      default: 'sidebar',
    },
    Id1: {
      type: String,
      default: '',
    },
    ActivatorId: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen && this.autoClose) {
        this.$nextTick(() => this.bindOutsideClick());
      } else {
        this.unbindOutsideClick();
      }
    },
  },
  beforeDestroy() {
    this.unbindOutsideClick();
  },
  methods: {
    bindOutsideClick() {
      this.unbindOutsideClick();
      this._onOutsideClick = e => {
        if (!this.value) return;

        const panel = document.getElementById(this.Id);
        if (panel && panel.contains(e.target)) {
          return;
        }

        const ignoreIds = [this.Id1, this.ActivatorId].filter(Boolean);
        for (let i = 0; i < ignoreIds.length; i += 1) {
          const el = document.getElementById(ignoreIds[i]);
          if (el && el.contains(e.target)) {
            return;
          }
        }

        this.$emit('input', false);
      };

      setTimeout(() => {
        document.addEventListener('click', this._onOutsideClick);
      }, 0);
    },
    unbindOutsideClick() {
      if (this._onOutsideClick) {
        document.removeEventListener('click', this._onOutsideClick);
        this._onOutsideClick = null;
      }
    },
  },
};
</script>
